import {
  NextText,
  TooltipContent,
} from "../../components/OnboardModalPopup/components";
import DEFAULT_PROPERTIES, {
  BILL_THIRD_TARGET,
  BILL_FOURTH_TARGET,
  BILL_FIFTH_TARGET,
  BILL_SIXTH_TARGET,
  BILL_SEVENTH_TARGET,
  BILL_EIGHTH_TARGET,
} from "../../constants";

const steps = [
  {
    ...DEFAULT_PROPERTIES,
    target: `#${BILL_THIRD_TARGET}`,
    content: (
      <TooltipContent
        title="Your uploaded invoice"
        description="Refer to this invoice preview to fill out the details correctly."
      />
    ),
    locale: {
      close: <NextText>Next</NextText>,
    },
    placement: "left",
  },
  {
    ...DEFAULT_PROPERTIES,
    disableScrolling: false,
    target: `#${BILL_FOURTH_TARGET}`,
    content: (
      <TooltipContent
        title="Invoice Overview & Recipient Details"
        description="Our smart OCR has captured and filled your invoice details. You just have to fill in the remaining fields."
      />
    ),
    locale: {
      back: <NextText>Back</NextText>,
      close: <NextText>Next</NextText>,
    },
    placement: "right",
  },
  {
    ...DEFAULT_PROPERTIES,
    disableScrolling: false,
    target: `#${BILL_FIFTH_TARGET}`,
    content: (
      <TooltipContent
        title="Transaction Details: Item List"
        description="You can modify this auto-generated list as well."
      />
    ),
    locale: {
      back: <NextText>Back</NextText>,
      close: <NextText>Next</NextText>,
    },
    placement: "right",
  },
  {
    ...DEFAULT_PROPERTIES,
    disableScrolling: false,
    target: `#${BILL_SIXTH_TARGET}`,
    content: (
      <TooltipContent
        title="Transaction Details: Taxes & Fees"
        description="Our system also identified all taxes & fees in your invoice. Add more if needed."
      />
    ),
    locale: {
      back: <NextText>Back</NextText>,
      close: <NextText>Next</NextText>,
    },
    placement: "right",
  },
  {
    ...DEFAULT_PROPERTIES,
    disableScrolling: false,
    target: `#${BILL_SEVENTH_TARGET}`,
    content: (
      <TooltipContent
        title="Transaction Details: Summary & Transfer Notes"
        description="Here's your invoice payment breakdown. You can also includes notes for the recipient."
      />
    ),
    locale: {
      back: <NextText>Back</NextText>,
      close: <NextText>Next</NextText>,
    },
    placement: "right",
  },
  {
    ...DEFAULT_PROPERTIES,
    disableScrolling: false,
    target: `#${BILL_EIGHTH_TARGET}`,
    content: (
      <TooltipContent
        title="Supporting Document"
        description="Attach any relevant document to help the Approver(s) identify your request."
      />
    ),
    locale: {
      back: <NextText>Back</NextText>,
      close: <NextText>Got it</NextText>,
    },
    placement: "right",
  },
];

const callback = ({ data, defaultState, setGuidedTourState }) => {
  const { index, action, lifecycle } = data ?? {};

  const stepCount = steps.length - 1;

  const isComplete = lifecycle === "complete";

  if (!isComplete) return;

  switch (action) {
    case "close":
      if (index < stepCount) {
        setGuidedTourState((prev) => ({
          ...prev,
          stepIndex: prev.stepIndex + 1,
        }));
        break;
      }
      if (index === stepCount) {
        setGuidedTourState(defaultState);
        break;
      }
      break;

    case "prev":
      if (index > 0) {
        setGuidedTourState((prev) => ({
          ...prev,
          stepIndex: prev.stepIndex - 1,
        }));
        break;
      }
      break;

    default:
      break;
  }
};

const billThirdPageProps = { steps, callback };

export default billThirdPageProps;
